import I18n from "i18n-js";

export function nomenclatureToTranslatedString(nomenclature) {
  if (!nomenclature || !nomenclature.designation) return;
  if (
    !nomenclature.translations ||
    !nomenclature.translations[I18n.locale].designation
  )
    return nomenclature.designation;
  else return nomenclature.translations[I18n.locale].designation;
}

export function nomenclatureFromUuid(nomenclatureArray, uuid) {
  const nomenclature = nomenclatureArray.find((n) => {
    return n.uuid === uuid;
  });
  return nomenclature;
}

export function nomenclatureDesignationFromUuid(nomenclatureArray, uuid) {
  const nomenclature = nomenclatureFromUuid(nomenclatureArray, uuid);
  return nomenclatureToTranslatedString(nomenclature);
}
